/* eslint-disable no-param-reassign */
import type { VehicleType } from "@daytrip/legacy-enums";
import { isUndefinedOrNull } from "@daytrip/utils";

import { Assignation } from "../models/Assignation";
import { SimpleOrderWithAssignationsAssignation } from "../models/SimpleOrderWithAssignationsAssignation";
import type { VehicleTypeAssignationPair } from "../models/VehicleTypeAssignationPair";

export function transformAssignationsToVehicleTypeAssignationsPairs(
    vehicleTypes: Array<VehicleType>,
    assignations: Array<Assignation | SimpleOrderWithAssignationsAssignation>,
): Array<VehicleTypeAssignationPair> {
    const result: Array<VehicleTypeAssignationPair> = [];

    vehicleTypes.forEach((vehicleType) => {
        const currentAssignation = assignations.find(
            (assignation) =>
                assignation.vehicleType === vehicleType && !assignation.cancelledAt && !assignation.declinedAt,
        );

        if (!isUndefinedOrNull(currentAssignation)) {
            if (currentAssignation instanceof SimpleOrderWithAssignationsAssignation) {
                assignations = assignations.filter(
                    (assignation) =>
                        assignation instanceof SimpleOrderWithAssignationsAssignation &&
                        assignation.assignationId !== currentAssignation.assignationId,
                );
            } else if (currentAssignation instanceof Assignation) {
                assignations = assignations.filter(
                    (assignation) => assignation instanceof Assignation && assignation._id !== currentAssignation._id,
                );
            }
        }

        result.push({
            vehicleType,
            assignation: currentAssignation,
        } as VehicleTypeAssignationPair);
    });

    return result;
}
